export default __webpack_public_path__ + "static/business-circle-ec918945dc9af9d049ebb83a3f716c73.png";